module.exports = __webpack_public_path__ + "img/info-gray-icon.a9082083.svg";